import { useState } from 'react'
import {
    Box, List, Badge, Button, Tooltip, Divider,
    IconButton, Typography, ListSubheader, CircularProgress,
    Stack,
} from '@mui/material'
import { Iconify } from '../../../../components/Iconify'
import Scrollbar from '../../../../components/scrollbar'
import MenuPopover from '../../../../components/menu-popover'
import { IconButtonAnimate } from '../../../../components/animate'
import { useNotificacionesContext } from '../../../../contexts/NotificacionesContext'
import { NotificacionItem } from './NotificacionItem'

const NotificacionesPopover = () => {

    const [openPopover, setOpenPopover] = useState(null)
    const [leyendo, setLeyendo] = useState(false)
    const [destroying, setDestroying] = useState(false)

    const { 
        notifs, updateLeerNotificacionesHook, 
        destroyNotificacionesHook 
    } = useNotificacionesContext()

    const sinLeer = notifs?.filter(n => (
        !n.no_leida
    ))

    const leidas = notifs?.filter(n => (
        !!n.no_leida
    ))

    const handleOpenPopover = (event) => {
        setOpenPopover(event.currentTarget)
    }

    const handleClosePopover = () => {
        setOpenPopover(null)
    }

    const onLeerTodas = async() => {
        setLeyendo(true)
        await updateLeerNotificacionesHook()
        setLeyendo(false)
    }

    const onDestroyAll = async() => {
        setDestroying(true)
        await destroyNotificacionesHook()
        setDestroying(false)
    }

    return (
        <>
            <IconButtonAnimate
                color={openPopover ? 'primary' : 'default'}
                onClick={handleOpenPopover}
                sx={{ width: 40, height: 40 }}
            >
                <Badge badgeContent={sinLeer?.length} color="error">
                    <Iconify icon="eva:bell-fill" />
                </Badge>
            </IconButtonAnimate>
            <MenuPopover open={openPopover} onClose={handleClosePopover} sx={{ width: 360, p: 0 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', py: 2, px: 2.5 }}>
                    <Box sx={{ flexGrow: 1 }}>
                        <Typography variant="subtitle1">Notificaciones</Typography>

                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            Tienes {sinLeer?.length} {sinLeer?.length === 1 ? 'mensaje' : 'mensajes'} sin leer
                        </Typography>
                    </Box>
                    {sinLeer?.length > 0 && (
                        <Tooltip title=" Marcar todas como leidas">
                            {leyendo ? (
                                <CircularProgress size={17} />
                            ) : (
                                <IconButton color="primary" onClick={onLeerTodas}>
                                <Iconify icon="eva:done-all-fill" />
                            </IconButton>
                            )}
                        </Tooltip>
                    )}
                </Box>
                <Divider sx={{ borderStyle: 'dashed' }} />
                <Scrollbar sx={{ height: { xs: 340, sm: 'auto' }, maxHeight: 500 }}>
                    {!!sinLeer?.length && (
                        <List
                            disablePadding
                            subheader={
                                <ListSubheader disableSticky sx={{ py: 1, px: 2.5, typography: 'overline' }}>
                                    Sin Leer
                                </ListSubheader>
                            }
                        >
                            {sinLeer?.map((n) => (
                                <NotificacionItem
                                    key={n.id}
                                    notif={n}
                                />
                            ))}
                        </List>
                    )}
                    {!!leidas?.length && (
                        <List
                            disablePadding
                            subheader={
                                <ListSubheader disableSticky sx={{ py: 1, px: 2.5, typography: 'overline' }}>
                                    Anteriores
                                </ListSubheader>
                            }
                        >
                            {leidas?.map((n) => (
                                <NotificacionItem
                                    key={n.id}
                                    notif={n}
                                />
                            ))}
                        </List>
                    )}
                </Scrollbar>
                {!!notifs?.length && (
                    <>
                        <Divider sx={{ borderStyle: 'dashed' }} />
                        <Box sx={{ p: 1 }}>
                            {destroying ? (
                                <Stack pt={1} pb={1} direction="row" alignItems="center" justifyContent="center">
                                    <CircularProgress size={24} />
                                </Stack>
                            ) : (
                                <Button fullWidth disableRipple onClick={onDestroyAll}>
                                    Eliminar todas
                                </Button>
                            )}
                        </Box>
                    </>
                )}
            </MenuPopover>
        </>
    )
}

export { NotificacionesPopover }
